import { useTranslation } from 'react-i18next';

import FaqsAccordion from '@/components/FaqsAccordion';

function Faqs() {
	const { t } = useTranslation();

	const faqs = t('faqs.items', {
		returnObjects: true
	});

	return (
		<FaqsAccordion
			faqList={faqs}
			className="mb-20 mt-7 gap-7 lg:mb-[120px] lg:mt-[72px] lg:gap-20"
		>
			<div className="flex flex-col items-start gap-3 text-left lg:items-center lg:text-center">
				<h1 className="whitespace-break-spaces font-title text-[32px] font-semibold leading-10 lg:text-[56px] lg:font-bold lg:leading-[64px]">
					{t('faqs.title')}
				</h1>
				<h2 className="text-sm font-normal leading-6 lg:text-base lg:leading-7">
					{t('faqs.description')}
				</h2>
			</div>
		</FaqsAccordion>
	);
}

export default Faqs;
